import {ReactNode, useState, useCallback} from 'react';

import {TestIdProps, Nullish} from 'shared/web';

import {ChoiceContextProvider} from '../hooks/choiceContext';

interface ChoiceProviderProps {
  options: TestIdProps & {hasOptionCheckbox?: boolean; 'data-name'?: string};
  children: ReactNode;
}

export const ChoiceProvider = ({children, options}: ChoiceProviderProps) => {
  const {hasOptionCheckbox} = options;
  const [imageCache, setImageCacheState] = useState<Map<string, string | Nullish>>(new Map());

  const setImageCache = useCallback((optionId: string, imageUrl: string | Nullish) => {
    setImageCacheState((prevCache) => {
      const newCache = new Map(prevCache);
      newCache.set(optionId, imageUrl);
      return newCache;
    });
  }, []);

  return (
    <ChoiceContextProvider
      value={{
        'data-testid': options['data-testid'],
        'data-name': options['data-name'],
        hasOptionCheckbox,
        imageCache,
        setImageCache,
      }}
    >
      {children}
    </ChoiceContextProvider>
  );
};
